import { Box, Stack } from "@mui/material";

import { TrendDelta } from "../../../components/TrendDelta";
import { formatDecimal, formatFraction, formatNumber } from "../../../utils/numberFormat";

/** Search Console top queries (`queries`), shared by the visibility panel and the report. */
export const SEARCH_QUERY_COLUMNS = [
  { key: "query", header: "Búsqueda", render: (row) => row.query },
  { key: "clicks", header: "Clics", align: "right", render: (row) => formatNumber(row.clicks) },
  { key: "impressions", header: "Impresiones", align: "right", render: (row) => formatNumber(row.impressions) },
  { key: "ctr", header: "CTR", align: "right", render: (row) => formatFraction(row.ctr) },
  {
    key: "position",
    header: "Posición",
    align: "right",
    render: (row) => (
      <Stack direction="row" spacing={1} justifyContent="flex-end" alignItems="center">
        <span>{formatDecimal(row.position)}</span>
        <Box sx={{ width: 48, display: "flex", justifyContent: "flex-end" }}>
          <TrendDelta value={row.position_change} maximumFractionDigits={1} size="small" />
        </Box>
      </Stack>
    ),
  },
];
